import Header from "../../layouts/Header"
import { styled, ThemeProvider, createTheme } from "@mui/material/styles"
import { Box } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import CustomReadableTableServer from "../../components/CustomReadableTableServerSide"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../utils/date/HHMMSSFormatHour"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87",
    },
  },
})

const VisorErroresSoho = () => {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Visor ZOHO</b>
        </div>

        <Box className={StyledRoot}>
          <CustomReadableTableServer
            endpoint="/IntegracionSoho/getVisorErroresAll"
            cacheOptions={{
              refetchOnWindowFocus: false,
              refetchOnMount: false,
              refetchOnReconnect: false,
              staleTime: Infinity,
              cacheTime: Infinity,
            }}
            endpointJson={{}}
            queryKeyModal="visorErroresSoho"
            perPage={10}
            errorMsgFilterSearch="Error al cargar los datos del visor de errores"
            columnsTable={[
              {
                accessorKey: "msgtipo",
                header: "Tipo",
                size: 80,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  const isSuccess = value.includes("S")

                  return isSuccess ? (
                    <CheckCircleIcon style={{ color: "#4CAF50", fontSize: "24px" }} />
                  ) : (
                    <CancelIcon style={{ color: "#F44336", fontSize: "24px" }} />
                  )
                },
              },
              {
                accessorKey: "ciacodigo",
                header: "Ciacodigo",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "ciadescri",
                header: "Descripción",
                size: 250,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgproceso",
                header: "Proceso",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgfecha",
                header: "Fecha y Hora",
                size: 200,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return (
                    <span>
                      {normalFormatDate(value)} {normalFormatHour(value)}
                    </span>
                  )
                },
              },
              {
                accessorKey: "msgusr",
                header: "Usuario",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgipconsumo",
                header: "IP Consumo",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "msgerror",
                header: "Error",
                size: 250,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default VisorErroresSoho
